import { useEffect, useRef, useState } from "react";
import {
  RemoveButton, SuggestionItem, SuggestionList,
  TagFieldGroup,
  TagInputField,
  TagSpan
} from "./tag-input.style";
import { MdRemoveCircle } from "react-icons/md";

const TagInput = ({ tags, setTags, suggestions, setSuggestions }) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([])
  const [isVisibleSuggestionList, setIsVisibleSuggestionList] = useState(false);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1)

  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Prüfen, ob der Klick innerhalb der TagInput-Komponente erfolgt ist
      if (ref.current && !ref.current.contains(event.target)) {
        setIsVisibleSuggestionList(false);
      }
    };

    // Registriere den Event-Listener, wenn die Komponente gemountet wird
    document.addEventListener("click", handleClickOutside);

    // Bereinige den Event-Listener, wenn die Komponente unmountet wird
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fk = inputValue.length > 0 && inputValue ? suggestions.filter(tag => tag.toLowerCase().includes(inputValue.trim().toLowerCase())) : [];
    setFilteredSuggestions(fk);
  }, [suggestions, inputValue]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    filteredSuggestions ? setIsVisibleSuggestionList(true) : setIsVisibleSuggestionList(false);
  };

  const formatKeyword = (keyword) => {
    return keyword.toLowerCase().replace(/\s+/g, '-');
  };

  const scrollToItem = (index) => {
    const item = document.querySelector(`#suggestion-item-${index}`);
    if (item) {
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  };

  const handleKeyDown = (e) => {
    // Anzahl der aktuellen Vorschläge
    const suggestionCount = filteredSuggestions.length;

    let newIndex = selectedSuggestionIndex;

    switch (e.key) {
      case "Enter":
        e.preventDefault();
        if (selectedSuggestionIndex >= 0 && selectedSuggestionIndex < suggestionCount) {
          const suggestion = filteredSuggestions[selectedSuggestionIndex];
          handleSuggestionClick(suggestion);
        } else if (inputValue) {
          // Füge das Keyword hinzu, wenn es nicht leer ist und keine Vorschläge sichtbar sind
          const formattedKeyword = formatKeyword(inputValue);
          if (!tags.includes(formattedKeyword)) {
            setTags((prevTags) => [...prevTags, formattedKeyword]);
            setInputValue("");
          }
        }
        break;
      case "ArrowUp":
        e.preventDefault()
        // Bewege den ausgewählten Vorschlag nach oben in der Liste
        newIndex = Math.max(selectedSuggestionIndex - 1, 0);
        setSelectedSuggestionIndex(newIndex);
        break;
      case "ArrowDown":
        e.preventDefault()
        newIndex = Math.min(selectedSuggestionIndex + 1, filteredSuggestions.length - 1);
        // Bewege den ausgewählten Vorschlag nach unten in der Liste
        setSelectedSuggestionIndex(newIndex);
        break;
      default:
    }
    scrollToItem(newIndex);
  };

  const handleSuggestionClick = (suggestion) => {
    if (!tags.includes(suggestion)) {
      setTags([...tags, suggestion]);
      setInputValue('');
      const filteredSuggestions = suggestions.filter(tag => tag !== suggestion);
      setSuggestions(filteredSuggestions);
      setIsVisibleSuggestionList(false);
    } else {
      const filteredSuggestions = suggestions.filter(tag => tag !== suggestion);
      setSuggestions(filteredSuggestions);
      setIsVisibleSuggestionList(false);
    }
  };

  const handleRemoveKeyword = (tagToRemove) => {
    setTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };

  return (
    <TagFieldGroup ref={ref}>
        {tags.map((tag) => (
          <TagSpan key={tag}>
            <small>{tag}</small>
            <RemoveButton type="button" onClick={() => handleRemoveKeyword(tag)}>
              <MdRemoveCircle/>
            </RemoveButton>
          </TagSpan>
        ))}
      <TagInputField
        type="text"
        id="keywords"
        name="keywords"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder="Mit Enter bestätigen"
      />
      { isVisibleSuggestionList && (
        <SuggestionList>
          {filteredSuggestions.map((suggestion, index) => (
            <SuggestionItem
              key={suggestion}
              id={`suggestion-item-${index}`}
              isSelected={index === selectedSuggestionIndex}
              onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion}
            </SuggestionItem>
          ))}
        </SuggestionList>
      )}
    </TagFieldGroup>
  );
};

export default TagInput;
